import React from 'react';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Generic EntityPickerInput
 * 
 * Reusable input component for any entity picker (Employee, Vessel, Department, etc.)
 * Supports disabled state, error handling, and view mode
 */
export function EntityPickerInput({
	label,
	isRequired = false,
	value,
	placeholder = "--Select--",
	error = false,
	errorMessage = "",
	onSelectClick,
	onClearClick,
	hasSelection = false,
	allowClear = true,
  allowAll = false,
	readOnly = true,
	viewMode = false,
	disabled = false,
	className = "",
	parentClassName = ""
}) {
	return (
		<div className={`mb-1 ${parentClassName}`}>
			{/* Label */}
			{label && (
				<label className="mb-1.5 block text-sm font-medium text-gray-600">
					{label}
					{isRequired && <span className="ml-1 text-red-500">*</span>}
				</label>
			)}

			{/* Input Container */}
			<div className="flex flex-row items-center">
				<input
					type="text"
					placeholder={ allowAll ? "All" : placeholder}
					value={value || ""}
					readOnly={readOnly}
					disabled={disabled}
					className={`w-full border border-solid border-gray-300 rounded-l-md px-3 py-2 focus:outline-none focus:ring focus:border-blue-300 text-gray-600 placeholder-gray-400 ${viewMode || disabled ? 'rounded-r-md' : ''} ${error ? 'border-red-500' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${className}`}
				/>
				{/* Show buttons only when NOT in viewMode and NOT disabled */}
				{!viewMode && !disabled && (
					!hasSelection || !allowClear ? (
						<button
              type="button"
							className={`flex items-center rounded-r-md border-none text-white h-[33px] cursor-pointer px-3 ${error ? 'bg-red-400 hover:bg-red-500' : 'bg-sky-400 hover:bg-sky-500'}`}
							onClick={onSelectClick}
						>
							<PersonSearchIcon />
						</button>
					) : (
						<button
              type="button"
							className="flex items-center rounded-r-md border-none bg-red-400 hover:bg-red-500 text-white h-[33px] cursor-pointer px-3"
							onClick={onClearClick}
						>
							<CancelIcon />
						</button>
					)
				)}
			</div>

			{/* Error message */}
			{error && errorMessage && (
				<span className="mt-1 block text-sm text-red-500">{errorMessage}</span>
			)}
		</div>
	);
}